module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "zk-radio"
  }, [_c('span', {
    staticClass: "zk-radio__input"
  }, [_c('span', {
    staticClass: "zk-radio__inner",
    class: {
      'is-disabled': _vm.disabled,
      'is-checked': _vm._value === _vm.label,
        'is-focus': _vm.focus
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm._value),
      expression: "_value"
    }],
    staticClass: "zk-radio__original",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.label,
      "checked": _vm._q(_vm._value, _vm.label)
    },
    on: {
      "focus": function($event) {
        _vm.focus = true
      },
      "blur": function($event) {
        _vm.focus = false
      },
      "__c": function($event) {
        _vm._value = _vm.label
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "zk-radio__label"
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-d0e2f8fe"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/radio/src/radio.vue
// module id = 283
// module chunks = 0